const theme = {
  colors: {
    primary: '#0078D4', // 主色调，类似Pimcore的蓝色
    secondary: '#00B294', // 次要色调
    accent: '#FFFFFF', // 强调色
    text: '#333333', // 文本颜色
    lightText: '#666666', // 浅色文本
    background: '#FFFFFF', // 背景色
    lightGray: '#F5F5F5', // 浅灰色背景
    darkGray: '#2D2D2D', // 深灰色背景（用于页脚）
    success: '#28a745', // 成功提示色
    warning: '#ffc107', // 警告提示色
    error: '#dc3545', // 错误提示色
  },
  fonts: {
    heading: "'Montserrat', 'Noto Sans SC', sans-serif",
    main: "'Roboto', 'Noto Sans SC', sans-serif",
  },
  fontSizes: {
    xs: '0.75rem',
    sm: '0.875rem',
    md: '1rem',
    lg: '1.25rem',
    xl: '1.5rem',
    xxl: '2rem',
    xxxl: '3rem',
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '3rem',
  },
  borderRadius: {
    small: '4px',
    medium: '8px',
    large: '16px',
    round: '50%',
  },
  shadows: {
    small: '0 2px 4px rgba(0, 0, 0, 0.1)',
    medium: '0 4px 8px rgba(0, 0, 0, 0.1)',
    large: '0 8px 16px rgba(0, 0, 0, 0.1)',
  },
  transitions: {
    fast: '0.2s ease',
    medium: '0.3s ease',
    slow: '0.5s ease',
  },
  breakpoints: {
    mobile: '576px',
    tablet: '768px',
    laptop: '992px',
    desktop: '1200px',
  },
};

export default theme;